// dependencies
import { useNavigate } from "react-router";

// components
import { ProjectCard } from "../projects/ProjectCard";

// hooks
import { useFetchTop3Projects } from "../../../hooks/useFirebase";

// styles
import styles from "./css/ShowcaseSection.module.css";


export default function ShowcaseSection() {
    const navigate = useNavigate();

    // get top 3 projects
    const { projects } = useFetchTop3Projects();
    
    const handleViewAllProjects = () => {
        navigate("/projects")
    }
    

    return (
        // background
        <div className={styles.showcaseSectionContainer}>
            {/* header, text | projects */}
            <div className={styles.contentContainer}>

                {/* header, text */}
                <div className={styles.textContainer}>
                    <div className={styles.headerText}>
                        <div className={styles.titleText}>
                            Project Showcase
                            <span className={styles.headerDivider}></span>
                        </div>
                        <button className={styles.learnMoreText} onClick={handleViewAllProjects}>
                            <span className={styles.learnMoreTextBit}>View all projects</span>
                            <span> &rarr;</span>
                        </button>
                    </div>
                </div>

                {/* projects */}
                <div className={styles.projectsContainer}>
                    <div className={styles.projectCardsContainer}>
                        {projects.length === 0 ? (
                            <p className="no-projects">No Projects Found</p>
                        ) : (
                            projects.map(({ id, title, description, thumbnail, tags }) => (
                                <ProjectCard
                                    key={id}
                                    id={id}
                                    title={title}
                                    description={description}
                                    thumbnail={thumbnail}
                                    tags={tags}
                                />
                            ))
                        )}
                    </div>
                </div>
                
            </div>
        </div>
    );
}
